import {files} from "./features/files";
import {testimonials} from "./features/testimonials";

export default () => {
    testimonials();
    files()
}
